import { useState } from "react";

import { useHistory } from "react-router";

import { Badge } from "@alpacahq/ui/old";

import { Path } from "~/v2/path";
import {
  RothIRAIcon,
  TraditionalIRAIcon,
} from "src/v2/components/common/IRAIcons";
import { FloatingButtons } from "../../../../components/common/FloatingButtons";
import type { IRAOnboardingProps } from "..";
import { SubTypeBox } from "./SubTypeBox";

export const SelectAccountSubType = ({
  rothIraAccount,
  traditionalIraAccount,
  subType,
  onSaveSessionState,
}: IRAOnboardingProps) => {
  const history = useHistory();
  const [selectedSubType, setSelectedSubType] = useState(subType);

  const onSubTypeClicked = (type: IRAOnboardingProps["subType"]) => () => {
    const newType = selectedSubType === type ? null : type;
    setSelectedSubType(newType);
  };

  const onSubmit = () => {
    if (!selectedSubType) {
      return;
    }
    onSaveSessionState({ subType: selectedSubType, step: "information" });
  };

  return (
    <div className="flex h-full w-full flex-col justify-between gap-8">
      <div className="flex flex-col gap-8">
        {!rothIraAccount && (
          <SubTypeBox
            title={"Roth IRA"}
            icon={<RothIRAIcon filled />}
            badge={<Badge variant="v2/emerald">Tax-Free Growth</Badge>}
            list={[
              "Contributions are after-tax.",
              "Ideal for people who expect to be in a higher tax bracket in retirement.",
            ]}
            onClick={onSubTypeClicked("roth")}
            isSelected={selectedSubType === "roth"}
          />
        )}
        {!traditionalIraAccount && (
          <SubTypeBox
            title={"Traditional IRA"}
            icon={<TraditionalIRAIcon filled />}
            badge={<Badge variant="v2/emerald">Tax-Deferred Growth</Badge>}
            list={[
              "Anyone with earned income can contribute.",
              "Ideal for people who expect to be in a lower tax bracket in retirement.",
            ]}
            onClick={onSubTypeClicked("traditional")}
            isSelected={selectedSubType === "traditional"}
          />
        )}
      </div>
      <FloatingButtons
        fixedOnBottom
        className="bg-white"
        next={{
          onClick: onSubmit,
          disabled: !selectedSubType,
        }}
        back={{
          onClick: () => history.push(Path.ROUTE_DASHBOARD),
        }}
      />
    </div>
  );
};
